export default {
  path: "/vendors",
  component: { template: `<router-view/>` },
  children: [
    {
      path: "vendors",
      component: () => import("@/components/Vendors/VendorsTable")
    },
    // {
    //   path: 'vendors-map',
    //   component: () => import('@/components/Vendors/VendorsMap')
    // },
    {
      path: "new-vendor",
      component: () => import("@/components/Vendors/NewVendor")
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/vendor.js